import type { SelectedAccessorialItem } from "~/features/quote/hooks/use-selected-accessorials.ts";

import styles from "./selected-accessorials.module.css";

export const SelectedAccessorials = ({
	accessorials,
}: {
	accessorials: SelectedAccessorialItem[];
}) => {
	return (
		<div>
			<div className={styles.accessorialRow}>
				{accessorials.length === 0 && <span>No accessorials selected</span>}
				{accessorials.map((accessorial) => (
					<div key={accessorial.id} title={accessorial.name}>
						{accessorial.name}
					</div>
				))}
			</div>
		</div>
	);
};
